import { BOOTSTRAP_GET_ELIGIBLE_ACCOUNT_TYPES_SUCCESS } from 'stash/store/bootstrapActions';

export const objectSet = (array, value = true) => {
	return array.reduce((acc, item) => {
		return {
			...acc,
			[item]: value,
		};
	}, {});
};

const eligible_account_types = (state = {}, action) => {
	switch (action.type) {
		case BOOTSTRAP_GET_ELIGIBLE_ACCOUNT_TYPES_SUCCESS: {
			return objectSet(action.response.eligible_account_types);
		}

		default:
			return state;
	}
};

export default eligible_account_types;
